const isProduction = process.env.NODE_ENV === 'production';

// Set base API URL depending on environment
export const API_BASE_URL = isProduction
  // ? 'For Production'
  ? 'https://www.amsapi.bsparksoftwaretechnologies.com/api'
    // ? 'For developement'
  // ? 'https://www.apitest.bsparksoftwaretechnologies.com/api'
  : 'http://localhost:5000/api';

export const API = {
  BASE: API_BASE_URL,
  FLAT_REGISTER :`${API_BASE_URL}/register`,
}